import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Check } from 'lucide-react';

const PaymentSection = ({ selectedPayment, onSelectPayment }) => {
  return (
    <Card className="bg-secondary border-border">
      <CardContent className="p-6">
        <h2 className="font-display text-xl font-bold text-foreground mb-6">
          Payment Method
        </h2>

        <div className="space-y-4">
          {/* PayPal Option - Primary */}
          <button
            onClick={() => onSelectPayment('paypal')}
            className={`w-full p-4 rounded-xl border-2 transition-all text-left ${
              selectedPayment === 'paypal'
                ? 'border-primary bg-primary/5'
                : 'border-border hover:border-primary/50 bg-background'
            }`}
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                {/* PayPal Logo */}
                <div className="w-12 h-8 flex items-center justify-center">
                  <svg className="h-6 w-auto text-foreground" viewBox="0 0 101 32" fill="currentColor">
                    <path d="M12.2 6.5H6.6c-.4 0-.7.3-.8.6L3.3 24.8c0 .3.2.5.5.5h2.7c.4 0 .7-.3.8-.6l.7-4.3c0-.3.4-.6.8-.6h1.8c3.6 0 5.7-1.7 6.3-5.2.2-1.5 0-2.7-.7-3.5-.8-1-2.1-1.6-4-1.6zm.6 5.1c-.3 2-1.8 2-3.2 2h-.8l.6-3.6c0-.2.2-.3.4-.3h.4c1 0 1.9 0 2.4.6.3.3.4.8.2 1.3z"/>
                    <path d="M35.2 11.5h-2.7c-.2 0-.4.1-.4.3l-.1.7-.2-.2c-.5-.8-1.7-1-2.9-1-2.7 0-5 2-5.5 4.9-.2 1.4.1 2.8 1 3.7.8.8 1.9 1.2 3.2 1.2 2.3 0 3.5-1.5 3.5-1.5l-.1.7c0 .3.2.5.5.5h2.4c.4 0 .7-.3.8-.6l1.4-9c0-.4-.2-.7-.5-.7zm-3.5 4.7c-.2 1.4-1.4 2.4-2.8 2.4-.7 0-1.3-.2-1.6-.6-.4-.4-.5-1-.4-1.6.2-1.4 1.4-2.4 2.8-2.4.7 0 1.3.2 1.6.6.4.4.5 1 .4 1.6z"/>
                  </svg>
                </div>
                <div>
                  <p className="font-semibold text-foreground">PayPal</p>
                  <p className="text-xs text-muted-foreground">Fast & secure checkout</p>
                </div>
              </div>
              <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${
                selectedPayment === 'paypal'
                  ? 'border-primary bg-primary'
                  : 'border-muted-foreground'
              }`}>
                {selectedPayment === 'paypal' && (
                  <Check className="h-4 w-4 text-primary-foreground" />
                )}
              </div>
            </div>
            {selectedPayment === 'paypal' && (
              <p className="text-xs text-primary mt-3 pl-15">
                Secure PayPal payment — UK-based company
              </p>
            )}
          </button>

          {/* Card Option - Secondary */}
          <button
            onClick={() => onSelectPayment('card')}
            className={`w-full p-4 rounded-xl border-2 transition-all text-left ${
              selectedPayment === 'card'
                ? 'border-primary bg-primary/5'
                : 'border-border hover:border-primary/50 bg-background'
            }`}
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                {/* Card Icons */}
                <div className="flex items-center gap-1">
                  <div className="w-8 h-5 bg-muted rounded flex items-center justify-center">
                    <span className="text-[8px] font-bold text-muted-foreground">VISA</span>
                  </div>
                  <div className="w-8 h-5 bg-muted rounded flex items-center justify-center">
                    <span className="text-[8px] font-bold text-muted-foreground">MC</span>
                  </div>
                </div>
                <div>
                  <p className="font-semibold text-foreground">Credit / Debit Card</p>
                  <p className="text-xs text-muted-foreground">Powered by Stripe</p>
                </div>
              </div>
              <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${
                selectedPayment === 'card'
                  ? 'border-primary bg-primary'
                  : 'border-muted-foreground'
              }`}>
                {selectedPayment === 'card' && (
                  <Check className="h-4 w-4 text-primary-foreground" />
                )}
              </div>
            </div>
          </button>
        </div>

        {/* Card Form Placeholder (would be Stripe Elements in production) */}
        {selectedPayment === 'card' && (
          <div className="mt-4 p-4 bg-background rounded-lg border border-border">
            <p className="text-sm text-muted-foreground text-center">
              Card payment form will appear here (Stripe Elements)
            </p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default PaymentSection;
